import { Deserializable } from '../deserializable';

export class CaseMessaging implements Deserializable {
  public SenderFirstName: string;
  public SenderLastName: string;
  public ReaderUserName?: string;
  public SamDownloadDate?: Date;
  public IsApplicationCaseDownloadedToSam: boolean;
  public CaseMessagingID: number;
  public CaseNumber?: number;
  public AgentID?: number;
  public StaffID?: number;
  public Content: string;
  public RequiresActionInternal?: boolean;
  public HideMessage?: boolean;
  public IsDownloadedToSam?: boolean;
  public DatePosted?: Date;
  public RequiresActionExternal?: boolean;
  public BranchUserID?: number;
  public DirectCustomerID?: number;
  public ReceivedByDirectCustomerID?: number;
  public ReadByStaffID?: number;
  public ReadByStaffAt?: Date;

  public deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
